'use client';

import React, { useState } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export const queryClientDefaultOptions = {
  queries: { staleTime: Infinity, gcTime: Infinity },
};

export function ReactQueryClientProvider({
  children,
}: {
  children?: React.ReactNode;
}) {
  const [queryClient] = useState(
    () => new QueryClient({ defaultOptions: queryClientDefaultOptions })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
      {children}
    </QueryClientProvider>
  );
}
